import { render, staticRenderFns } from "./BusinessesTable.vue?vue&type=template&id=36052449&"
import script from "./BusinessesTable.vue?vue&type=script&lang=ts&"
export * from "./BusinessesTable.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports